import { MimeTypeEnum } from "./utils/enums";

/** Storybook constants */
export const SB_PROGRAM_ID = "123";
export const SB_REGISTRATION_ID = "123";
export const SB_PROGRAM_PARTICIPANT_ID = "123";
export const SB_PROGRAM_ORGANISATION_ID = "123";
export const SB_REGISTRATION_PARTICIPANT_ID = "123";

export const MIME_TYPE_FILE_EXT_MAP = {
  [MimeTypeEnum.PDF_MIME_TYPE]: ".pdf",
  [MimeTypeEnum.IMAGE_PNG_MIME_TYPE]: ".png",
  [MimeTypeEnum.IMAGE_JPEG_MIME_TYPE]: ".jpeg",
  [MimeTypeEnum.IMAGE_JPG_MIME_TYPE]: ".jpg",
  [MimeTypeEnum.IMAGE_SVG_MIME_TYPE]: ".svg",
  [MimeTypeEnum.CSV_MIME_TYPE]: ".csv"
};
